// External libraries
import PropTypes from 'prop-types';
import React from 'react';
import styled, { withTheme } from 'styled-components';

// Zocdoc libraries
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    font-family: ${FontFamily.SharpSansMedium};
    min-height: 100vh;
    overflow-x: hidden;

    > * {
        flex-shrink: 0;
    }
`;

export class BasePage extends React.Component {
    static propTypes = {
        theme: PropTypes.shape({
            faviconUri: PropTypes.string,
        }),
    };

    componentDidMount() {
        // only inject favicon if it hasnt already been rendered by node web server
        const $existingFavicon = document.querySelector(
            '[rel="shortcut icon"]'
        );
        if (!$existingFavicon) {
            this.$favicon = document.createElement('link');

            this.$favicon.rel = 'icon';
            this.$favicon.href = this.props.theme.faviconUri;
            this.$favicon.setAttribute('sizes', '32x32');
            document.head.appendChild(this.$favicon);
        }
    }

    componentDidUpdate(prevProps) {
        if (
            this.$favicon &&
            prevProps.theme.faviconUri !== this.props.theme.faviconUri
        ) {
            this.$favicon.href = this.props.theme.faviconUri;
        }
    }

    componentWillUnmount() {
        if (this.$favicon) {
            document.head.removeChild(this.$favicon);
            this.$favicon = null;
        }
    }

    render() {
        return <Container {...this.props}>{this.props.children}</Container>;
    }
}

const Page = withTheme(BasePage);

export { Page as default, Page };
